import { actions } from 'react-table';

import { StateReducer } from './createStateReducer';

export function ensureToggleSortByDirection<
  D extends Record<string, unknown>
>() {
  return ({ state, action, instance, ...rest }: StateReducer<D>) => {
    if (action.type === actions.toggleSortBy && instance) {
      // action.desc (a react-table internal) appears to be broken and is
      // always showing undefined. I am manually calculating the sort order by
      // fetching the current column sort state and then forwarding it one
      // step in the order.
      const column = instance.allColumns.find(
        ({ id }) => id === action.columnId
      );
      if (column) {
        const desc = (() => {
          if (typeof column.isSortedDesc === 'undefined') return false;
          if (column.isSortedDesc === true) return undefined;
          if (column.isSortedDesc === false) return true;
          return undefined;
        })();
        return { state, action: { ...action, desc }, instance, ...rest };
      }
    }
    return { state, action, instance, ...rest };
  };
}
